import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Toast from 'Components/toaster/Toast';

const ToastContainer = ({ dismiss, list, map }) => (
  <div className="toaster__toast-container">
    <TransitionGroup className="toaster__transition-container">
      {list.map((id) => (
        <CSSTransition classNames="toaster__fade" key={id} timeout={300}>
          <Toast onDismiss={dismiss} toast={map[id]} />
        </CSSTransition>
      ))}
    </TransitionGroup>
  </div>
);

export default ToastContainer;
